import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const LogoutIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg viewBox="0 0 21 21" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M13.016 5.3895V4.4565C13.016 2.4215 11.366 0.7715 9.33097 0.7715H4.45597C2.42197 0.7715 0.771973 2.4215 0.771973 4.4565V15.5865C0.771973 17.6215 2.42197 19.2715 4.45597 19.2715H9.34097C11.37 19.2715 13.016 17.6265 13.016 15.5975V14.6545" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" stroke="currentColor" /><path d="M19.8095 10.0214H7.76849" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /><path d="M16.8812 7.1063L19.8092 10.0213L16.8812 12.9373" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};